export default __webpack_public_path__ + "static/imgSix-2e9bd3f8286f4211cd8ff57e1d11541d.jpg";